export default __webpack_public_path__ + "static/media/SMART_SET.11a561d5.svg";